export default __webpack_public_path__ + "static/media/img1.c04640b3.jpg";